<script>
import WootSnackbar from './Snackbar.vue';
import { emitter } from 'shared/helpers/mitt';

let lastToastKey = 0;

export default {
  components: {
    WootSnackbar,
  },
  props: {
    duration: {
      type: Number,
      default: 5500,
    },
  },

  data() {
    return {
      snackMessages: [],
    };
  },

  mounted() {
    emitter.on('newToastMessage', this.onNewToastMessage);
  },
  unmounted() {
    emitter.off('newToastMessage', this.onNewToastMessage);
    this.snackMessages.forEach(item => clearTimeout(item.timer));
  },
  methods: {
    onNewToastMessage({ message: originalMessage, action, timeout }) {
      // FIX ME: This is a temporary workaround to pass string from functions
      // that doesn't have the context of the VueApp.
      const usei18n = action?.usei18n;
      const duration = timeout || action?.duration || this.duration;
      const message = usei18n ? this.$t(originalMessage) : originalMessage;

      // The same toast is already on screen (e.g. the same save error after a
      // retried click): restart its timer instead of stacking a duplicate.
      const existing = this.snackMessages.find(
        item => item.message === message
      );
      if (existing) {
        clearTimeout(existing.timer);
        existing.timer = this.scheduleRemoval(existing.key, duration);
        this.bringToTop();
        return;
      }

      lastToastKey += 1;
      const key = lastToastKey;
      this.snackMessages.push({
        key,
        message,
        action,
        timer: this.scheduleRemoval(key, duration),
      });
      this.$nextTick(this.bringToTop);
    },
    // A dialog opened with showModal() sits in the browser top layer, above
    // any z-index. Showing the container as a popover puts it in the top
    // layer too; re-showing it moves it above dialogs opened after it.
    bringToTop() {
      const el = this.$refs.snackbarContainer;
      if (typeof el?.showPopover !== 'function') return;
      try {
        if (el.matches(':popover-open')) el.hidePopover();
        el.showPopover();
      } catch (e) {
        // The element is not connected or not a valid popover: keep the
        // z-index fallback.
      }
    },
    scheduleRemoval(key, duration) {
      return setTimeout(() => {
        this.snackMessages = this.snackMessages.filter(
          item => item.key !== key
        );
      }, duration);
    },
  },
};
</script>

<template>
  <div
    ref="snackbarContainer"
    popover="manual"
    class="fixed top-4 left-1/2 -translate-x-1/2 max-w-[25rem] w-[calc(100%-2rem)] text-center bg-transparent border-0 p-0 m-0 outline-none overflow-visible z-[9999]"
  >
    <transition-group name="toast-fade" tag="div">
      <WootSnackbar
        v-for="snackMessage in snackMessages"
        :key="snackMessage.key"
        :message="snackMessage.message"
        :action="snackMessage.action"
      />
    </transition-group>
  </div>
</template>
